import styled from "@emotion/styled";
import { Col, Row, Table } from "antd";
import { CustomButon } from "./CommonHeader";
import touzi4 from "../../../../images/touzi-4.png";
import jiansheImg from "../../../../images/jianshe-4.png";
import jianshebox from "../../../../images/jianshe-box.png";
import jiansheActive from "../../../../images/jianshe-item.png";
import th from "../../../../images/th1.png";
import tr from "../../../../images/tr.png";
import { ColumnsType } from "antd/es/table/interface";
import YearPicker from "../../../../components/YearPicker";
import xiangmuImg from "../../../../images/xiangmu-6.png";
import { DualAxes } from "@ant-design/plots";
import line3 from "../../../../images/line3.png";
import { useCallback, useEffect, useState } from "react";
import request from "../../../../utils/request";

const Layout = styled.div`
  .flex {
    display: flex;
  }
  .ac {
    align-items: center;
  }
  .column {
    flex-direction: column;
  }
  .box-item {
    background-color: rgba(1, 104, 126, 0.9);
    border: 2px solid #00c9d0;
    box-shadow: 0 0 12px #00383f;
    border-radius: 8px;
    padding: 20px 25px;
    width: 1545px;
    margin-top: 15px;
  }

  .base-info-btn {
    color: #fff;
    font-weight: bold;
    font-size: 20px;

    align-items: center;
    img {
      margin-right: 5px;
    }
    span {
      margin-left: 8px;
    }
  }
  .table-wrapper {
    margin-top: 33px;
  }

  .ant-table {
    background-color: transparent;
    thead {
      background-image: url(${th});
    }
    th {
      background-color: transparent !important;
      color: #fff !important;
      font-size: 14px !important;
      border: none !important;
      height: 40px !important;
      padding: 0 !important;
      &::before {
        display: none !important;
      }
    }
    td {
      color: #1cfbff !important;
      border: none !important;
      background-color: transparent !important;
    }
    tr:hover {
      td {
        background-color: transparent !important;
        border: none !important;
      }
    }
    tbody tr {
      background-image: url(${tr});
      border: none !important;
      &:nth-child(odd) {
        // background-image: url();
      }
    }
  }
`;

export const Intellectual: React.FC<{
  id?: number;
}> = ({ id }) => {
  const [details, setDetails] = useState<Record<string, any>[]>([]);

  const getData = useCallback(() => {
    if (!id) return;
    request.get("/screen/Index/getCompanyPatent?id=" + id).then((res) => {
      console.log("res", res);
      setDetails(res.data?.data || []);
    });
  }, [id]);

  useEffect(() => {
    getData();
  }, [getData]);

  const columns: ColumnsType<any> = [
    {
      title: "序号",
      dataIndex: "",
      align: "center",
      render(value, record, index) {
        return index + 1;
      },
    },
    {
      title: "申请号",
      align: "center",
      dataIndex: "numbers",
    },
    {
      title: "专利类型",
      align: "center",
      dataIndex: "sq",
    },
    {
      title: "专利名称",
      align: "center",
      dataIndex: "title",
    },
    {
      title: "申请人",
      align: "center",
      dataIndex: "company",
    },
    {
      title: "申请日",
      align: "center",
      dataIndex: "stime",
    },
    {
      title: "授权入库日",
      align: "center",
      dataIndex: "etime",
    },
    {
      title: "案卷统计年份",
      align: "center",
      dataIndex: "years",
    },
    {
      title: "案卷统计月份",
      align: "center",
      dataIndex: "month",
    },
    {
      title: "申请(专利权)人类型",
      align: "center",
      dataIndex: "type",
    },
    {
      title: "代理机构名称",
      align: "center",
      dataIndex: "desc",
    },
    {
      title: "主分类号",
      align: "center",
      dataIndex: "sn",
    },
  ];

  return (
    <Layout>
      <div className="box-item table-box">
        <div className="base-info-btn flex">
          <img src={line3} width="7" height="21" alt="" />
          <span>专利</span>
        </div>
        <div className="table-wrapper">
          <Table
            columns={columns}
            pagination={false}
            dataSource={details}
            locale={{
              emptyText: "暂无数据",
            }}
          />
        </div>
      </div>
    </Layout>
  );
};
